





















import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import SettingsButton from "@/components/SettingsButton.vue";

const History = namespace("history");

@Component({
  components: { SettingsButton }
})
export default class HistoryButtons extends Vue {
  @History.Action("undo")
  private undo!: () => void;

  @History.Action("redo")
  private redo!: () => void;

  @History.Getter("canUndo")
  private canUndo!: boolean;

  @History.Getter("canRedo")
  private canRedo!: boolean;
}
